import AuthenticationLinks from '../authentication-links/AuthenticationLinks';
import InfoIcon from '../icons/InfoIcon';
import PencilIcon from '../icons/PencilIcon';
import PriceCell from '../price-cell/PriceCell';
import Redirect from '../icons/Redirect';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { Body, BodyBold, BodyGrey } from '../Typography';
import { Box, Button, styled } from '@mui/material';
import { HFlex, VFlex } from '../FlexContainers';
import { LinkButton, PrimaryButton } from '../Buttons';
import { palette } from '../../theme/palette';

export const Root = styled(Box)`
  padding: 40px 25px;
`;

export const RootWithBG = styled(Root)`
  padding: 40px 25px;
  background: #f6f6f6;
`;

export const CheckoutSummaryRoot = styled(Box)`
  padding: 30px 0px;
  @media (max-width: 991px) {
    padding: 20px 0px;
  }
`;

export const CartSummaryContent = styled(Box)`
  padding: 0 10px;
`;

export const CartLineItem = styled(Box)`
  display: grid;
  grid-template-areas: 'CartItemImageBox CartItemContentBox CartItemPriceBox';
  grid-template-columns: 70px 1fr auto;
  grid-template-rows: auto;
  column-gap: 25px;
  @media (max-width: 768px) {
    grid-template-areas:
      'CartItemImageBox CartItemContentBox'
      'CartItemImageBox CartItemPriceBox';
    grid-template-columns: 70px 1fr;
    grid-template-rows: auto auto;
    column-gap: 25px;
  }
`;

export const CartItemImageBox = styled(Box)`
  grid-area: CartItemImageBox;
  /* padding: 10px 10px 10px 0px; */
  width: 70px;
  height: 70px;
  position: relative;
`;

export const CartItemContentBox = styled(VFlex)`
  grid-area: CartItemContentBox;
  flex: 1;
`;

export const CartItemPriceBox = styled(HFlex)`
  grid-area: CartItemPriceBox;
  min-width: 60px;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: row-reverse;
    .price-type-label {
      margin: 0px 0px 0px 10px;
    }
  }
`;

export const CartItemImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 5px;
  background: white;
`;

export const CartItemCount = styled(Box)`
  border-radius: 50%;
  background-color: #373a36;
  color: white;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -10px;
  right: -15px;
  font-size: 12px;
`;

export const CartItemTitle = styled(BodyBold)``;

export const CartItemDetail = styled(Body)`
  color: #24242dbf;
`;

export const CartItemPrice = styled(PriceCell)`
  .price-cell-typography {
    letter-spacing: 0.35px;
    color: ${palette.custom.darkGrey};
    width: fit-content;
    font-size: 14px;
    font-weight: 700;
    text-align: right;
  }
`;

export const CartActions = styled(HFlex)`
  width: 100%;
  justify-content: flex-end;
  gap: 30px;
  margin: 20px 0;
  @media (max-width: 768px) {
    margin-top: 30px;
    margin-left: 3px;
    justify-content: flex-start;
  }
`;

export const CartAction = styled(LinkButton)`
  color: rgba(55, 58, 54, 1);
  text-transform: capitalize;
`;

export const SummaryLineItems = styled(VFlex)`
  margin-bottom: 15px;
`;

export const SummaryItem = styled(HFlex)`
  align-items: center;
  gap: 8px;
  padding: 10px;
  margin-left: -10px;
  margin-right: -10px;
  border-radius: 5px;
  &:nth-of-type(even) {
    background: white;
  }
`;

export const SummaryItemLabel = styled(Body)`
  text-transform: capitalize;
  margin-bottom: 0px;
`;

export const SummaryItemAmount = styled(PriceCell)`
  margin-left: auto;
  .price-cell-typography {
    color: ${palette.custom.darkGrey};
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.35px;
    width: fit-content;
  }
`;

export const EditIcon = styled(PencilIcon)`
  width: 20px;
`;

export const Seperator = styled('hr')`
  width: 100%;
  margin: 18px 0 20px 0;
  border-top-color: rgb(36 36 45 / 20%);
  border-left-width: 0px;
  border-right: 0px;
`;

export const BranchContent = styled(HFlex)`
  gap: 20px;
  justify-content: space-between;
`;

export const BranchLabel = styled(BodyGrey)`
  font-size: 12px;
  text-transform: uppercase;
  white-space: nowrap;
  margin-top: 2px;
`;

export const BranchDetails = styled(VFlex)`
  align-items: flex-end;
`;

export const BranchName = styled(BodyBold)`
  text-align: end;
`;

export const BranchLocationAddress = styled(BodyGrey)`
  text-align: end;
  letter-spacing: 0.35px;
`;

export const BranchDirectionLink = styled(LinkButton)`
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.025em;
  text-align: right;
  width: fit-content;
  color: ${palette.custom.mediumGrey};
  text-decoration: none;
  cursor: pointer;
  text-transform: capitalize;
  .MuiButton-endIcon {
    margin-right: 0;
  }
`;

export const BranchDirectionIcon = styled(Redirect)`
  color: ${palette.custom.black};
`;

export const Total = styled(Box)`
  padding: 10px;
  margin-left: -10px;
  margin-right: -10px;
`;

export const TotalSubtitle = styled(Body)`
  font-weight: 700;
  font-size: 15px;
  margin-bottom: 0px;
`;

export const TotalAmount = styled(PriceCell)`
  height: 55px;
  .price-cell-typography {
    font-family: trade-gothic-next-condensed, sans-serif;
    color: ${palette.custom.darkGrey};
    text-transform: uppercase;
    font-weight: 800;
    width: fit-content;
    font-size: 28px;
    margin-bottom: 0px;
  }
`;

export const CartPageActions = styled(VFlex)`
  gap: 15px;
`;

export const CheckoutAction = styled(PrimaryButton)`
  height: 40px;

  &.Mui-disabled {
    color: ${palette.custom.white};
    font-weight: 700;
    opacity: 0.5;
  }
`;

export const RequestQuoteAction = styled(PrimaryButton)`
  height: 40px;
  background: none;
  color: ${palette.primary.main};
  border: 2px solid ${palette.primary.main};
  :hover {
    background: none;
    color: ${palette.primary.main};
    border: 2px solid ${palette.primary.main};
  }
`;

export const MUITooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  '.MuiTooltip-tooltip': {
    padding: '15px 15px 15px 15px',
    backgroundColor: palette.custom.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: '0px 0px 10px -2px rgba(0, 0, 0, 0.15)',
    borderRadius: '5px',
  },
  '.MuiTooltip-arrow': {
    color: palette.custom.white,
    fontSize: 30,
  },
  '.MuiTooltip-arrow::before ': {
    border: '2px solid #eeeeee99',
    borderRadius: '5px',
  },
}));

export const TooltipContentWrapper = styled(HFlex)`
  gap: 15px;
`;

export const TooltipIconWrapper = styled(HFlex)`
  align-items: center;
`;

export const TooltipText = styled(Body)`
  color: rgba(36, 36, 45, 0.8);
  margin-bottom: 0;
`;

export const TooltipButton = styled(Button)`
  color: ${palette.custom.darkGrey};
  min-width: unset;
  padding: 0;
  padding-left: 2.5px;
  background: none;
  :hover {
    background: none;
  }
`;

export const TooltipIcon = styled(InfoIcon)`
  width: 20px;
`;

export const SignInAndSignUpLinks = styled(AuthenticationLinks)`
  margin-top: 14px;
  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-top: 10px;
  }
`;
